const GENDER = [
    { value: "MALE", label: "Masculino" },
    { value: "FEMALE", label: "Feminino" },
];

export default GENDER